import React, { useEffect, useState } from 'react'

import {
    NoticeBox,
    NoticeBoxColors,
    NoticeBoxVariants,
    VsInformationIcon,
} from '@octane/spark'
import styled from 'styled-components'
import FadeIn from 'utils/animations/FadeIn.styled'

import { BannerText, NoticeBoxWrapper } from './InformationSection.styled'

const SESSION_STORAGE_KEY = 'InformationSection'

const InfoIcon = styled(VsInformationIcon).attrs(({ theme }) => ({
    color: theme.colors.brand.primary,
}))``

function getSessionStorageKey(id: string) {
    return `${SESSION_STORAGE_KEY}_${id}`
}

function getSessionStorageOrDefault(key: string, defaultValue: boolean) {
    const stored = sessionStorage.getItem(key)

    if (!stored) {
        return defaultValue
    }

    return JSON.parse(stored)
}

type InformationSectionProps = {
    id: string
    bannerText?: React.ReactNode
    height?: string
}

export default function InformationSection({
    id,
    height,
    bannerText = '',
}: InformationSectionProps) {
    const sessionStorageKey = getSessionStorageKey(id)

    const [bannerVisibility] = useState(
        getSessionStorageOrDefault(sessionStorageKey, true),
    )

    useEffect(() => {
        window.sessionStorage.setItem(
            sessionStorageKey,
            String(bannerVisibility),
        )
    }, [bannerVisibility, sessionStorageKey])

    if (!bannerVisibility) return null

    return (
        <FadeIn delay={100} duration={350}>
            <NoticeBoxWrapper>
                <NoticeBox
                    style={{ height }}
                    icon={InfoIcon}
                    color={NoticeBoxColors.NOTE}
                    variant={NoticeBoxVariants.BOX}
                    iconPosition="middle"
                    className="information_section"
                    data-testid="information_section"
                >
                    {bannerText && <BannerText>{bannerText}</BannerText>}
                </NoticeBox>
            </NoticeBoxWrapper>
        </FadeIn>
    )
}
